





































































































































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarComunitationStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfNetworkStreamax'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.networkTypeModule1.value = this.data['?column?'].MP.NM;
    console.log(this.data['?column?'].MP.NM);
    this.formFields.networkTypeModule1.value = this.data['?column?'].M4G.NM;
    this.formFields.apnModule1.value = this.data['?column?'].MP.APN;
    this.formFields.apnModule2.value = this.data['?column?'].M4G.APN;
    this.formFields.usernameModule1.value = this.data['?column?'].MP.UN;
    this.formFields.usernameModule2.value = this.data['?column?'].M4G.UN;
    this.formFields.passwordModule1.value = this.data['?column?'].MP.PW;
    this.formFields.passwordModule2.value = this.data['?column?'].M4G.PW;
    this.formFields.numberModule1.value = this.data['?column?'].MP.AN;
    this.formFields.numberModule2.value = this.data['?column?'].M4G.AN;
    this.formFields.activeMode.value = parseInt(this.data['?column?'].M3M.AT);
    this.formFields.number1.value = this.data['?column?'].M3M.TN1;
    this.formFields.number2.value = this.data['?column?'].M3M.TN2;
    this.formFields.number3.value = this.data['?column?'].M3M.TN3;
  }
  mounted() {
    this.getTime();
  }
  convertirSegundosAHora(segundos: number): string {
    console.log('prueba:' + segundos);
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const horaString = horas.toString().padStart(2, '0');
    const minutosString = minutos.toString().padStart(2, '0');
    return `${horaString}${minutosString}`;
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    serverTypeModule1: any;
    networkTypeModule1: any;
    apnModule1: any;
    usernameModule1: any;
    passwordModule1: any;
    numberModule1: any;
    certificationModule1: any;
    serverTypeModule2: any;
    networkTypeModule2: any;
    apnModule2: any;
    usernameModule2: any;
    passwordModule2: any;
    numberModule2: any;
    certificationModule2: any;
    number1: any;
    number2: any;
    number3: any;
    activeMode: any;
  } = {
    serverTypeModule1: {
      label: 'Server Type',
      value: 'WCDMA',
    },
    networkTypeModule1: {
      label: 'Network Type',
      value: 0,
      items: [
        { label: 'Mix', id: 0 },
        { label: '2G', id: 1 },
        { label: '3G', id: 2 },
        { label: '4G', id: 3 },
      ],
    },
    apnModule1: {
      label: 'APN',
      value: 'm2m.movistar.cl',
    },
    usernameModule1: {
      label: 'User Name',
      value: 'web',
    },
    passwordModule1: {
      label: 'Password',
      value: 'web',
    },
    numberModule1: {
      label: 'Center Server',
      value: '*99#',
    },
    certificationModule1: {
      label: 'Certification',
      value: '0',
      items: [
        { label: 'None', id: '0' },
        { label: '', id: '1' },
        { label: '', id: '2' },
      ],
    },
    serverTypeModule2: {
      label: 'Server Type',
      value: 'No service',
    },
    networkTypeModule2: {
      label: 'Network Type',
      value: 0,
      items: [
        { label: 'Mix', id: 0 },
        { label: '2G', id: 1 },
        { label: '3G', id: 2 },
        { label: '4G', id: 3 },
      ],
    },
    apnModule2: {
      label: 'APN',
      value: '',
    },
    usernameModule2: {
      label: 'User Name',
      value: '',
    },
    passwordModule2: {
      label: 'Password',
      value: '',
    },
    numberModule2: {
      label: 'Center Server',
      value: '',
    },
    certificationModule2: {
      label: 'Certification',
      value: '0',
      items: [
        { label: 'None', id: '0' },
        { label: '', id: '1' },
        { label: '', id: '2' },
      ],
    },
    number1: {
      label: 'Number 1',
      value: '',
    },
    number2: {
      label: 'Number 2',
      value: '',
    },
    number3: {
      label: 'Number 3',
      value: '',
    },
    activeMode: {
      label: '',
      value: 0,
      items: [
        { label: 'Always Connected', id: 0 },
        { label: 'Phone or SMS activation', id: 1 },
        { label: 'I/O Activation', id: 2 },
      ],
    },
  };
  selectedActiveMode() {
    return this.formFields.activeMode.items.find(
      (item: { id: any }) => item.id === this.formFields.activeMode.value
    );
  }
  selectedCertificationModule1() {
    return this.formFields.certificationModule1.items.find(
      (item: { id: any }) =>
        item.id === this.formFields.certificationModule1.value
    );
  }
  selectedCertificationModule2() {
    return this.formFields.certificationModule2.items.find(
      (item: { id: any }) =>
        item.id === this.formFields.certificationModule2.value
    );
  }
  selectedNetworkTypeModule1() {
    return this.formFields.serverTypeModule1.items.find(
      (item: { id: any }) => item.id === this.formFields.serverTypeModule1.value
    );
  }
  selectedNetworkTypeModule2() {
    return this.formFields.serverTypeModule2.items.find(
      (item: { id: any }) => item.id === this.formFields.serverTypeModule2.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
